module.exports = __webpack_public_path__ + "img/23.8bad946e.jpg";